import { render, staticRenderFns } from "./ReviewExerciseStaff.vue?vue&type=template&id=90aa47f2"
import script from "./ReviewExerciseStaff.vue?vue&type=script&lang=js"
export * from "./ReviewExerciseStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports